// topoEditor/tokenize.js — pure: split a plain-text value into ordered segments using entity patterns.
//
// Value model = plain text + convention (Option 2): each entity owns its convention (a RegExp) and a
// parse() that lifts a match into structured data. Tokens are DERIVED from the string, never the source
// of truth — the string stays the stored value. This keeps storage backward-compatible.
//
// An entity: { kind: string, pattern: RegExp, parse(match) -> data }.

function global(pattern) {
    return pattern.flags.includes("g") ? pattern : new RegExp(pattern.source, pattern.flags + "g");
}

// text + entities -> [{ type:'text', text } | { type:'entity', kind, data, raw }] in document order.
// Overlapping matches are resolved earliest-start-wins (later overlaps are dropped).
export function tokenize(text, entities) {
    const hits = [];
    entities.forEach((entity) => {
        const re = global(entity.pattern);
        let m;
        while ((m = re.exec(text))) {
            if (m[0] === "") { re.lastIndex++; continue; }
            hits.push({ start: m.index, end: m.index + m[0].length, kind: entity.kind, data: entity.parse(m), raw: m[0] });
        }
    });
    hits.sort((a, b) => a.start - b.start || b.end - a.end);

    const segments = [];
    let pos = 0;
    hits.forEach((h) => {
        if (h.start < pos) { return; }
        if (h.start > pos) { segments.push({ type: "text", text: text.slice(pos, h.start) }); }
        segments.push({ type: "entity", kind: h.kind, data: h.data, raw: h.raw });
        pos = h.end;
    });
    if (pos < text.length) { segments.push({ type: "text", text: text.slice(pos) }); }
    return segments;
}

// Replace the n-th (0-based) occurrence of `pattern` in text with `replacement` — used when an entity
// edit (e.g. a link's href) is saved back into the plain-text value.
export function replaceNthMatch(text, pattern, n, replacement) {
    let i = -1;
    return text.replace(global(pattern), (whole) => {
        i += 1;
        return i === n ? replacement : whole;
    });
}
